import React from 'react';

/**
 * Header component for the chat widget.
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Title of the chat
 * @param {string} props.logo - URL to the logo image
 * @param {Function} props.onClose - Callback when close button is clicked
 * @param {Function} props.onExpand - Callback when expand button is clicked
 * @param {boolean} props.isExpanded - Whether chat is in expanded mode
 * @returns {JSX.Element} Header component
 */
const Header = ({ title, logo, onClose, onExpand, isExpanded }) => {
    return (
        <div className="talkflow-header">
            {logo && (
                <div className="talkflow-logo">
                    <img src={logo} alt={title} />
                </div>
            )}
            <div className="talkflow-title">{title || 'Trung Tâm'}</div>
            <div className="talkflow-controls">
                {onExpand && (
                    <button
                        className="talkflow-expand-button"
                        onClick={onExpand}
                        aria-label={isExpanded ? "Thu nhỏ" : "Mở rộng"}
                        title={isExpanded ? "Thu nhỏ" : "Mở rộng"}
                    >
                        <i className={`fa-solid ${isExpanded ? 'fa-compress' : 'fa-expand'}`}></i>
                    </button>
                )}
                {onClose && (
                    <button
                        className="talkflow-close-button"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Header;
